import React, { useState } from "react";
import { StudioSelectorProps } from "../types";

const StudioSelector: React.FC<StudioSelectorProps> = ({
  studios,
  selectedStudios,
  onSelection,
  onBack,
  currentStep,
}) => {
  const [localSelected, setLocalSelected] = useState<string[]>(selectedStudios);

  const handleStudioToggle = (studioId: string): void => {
    setLocalSelected([studioId]);
  };

  const handleNext = (): void => {
    if (localSelected.length === 0) {
      alert("Please select at least one studio");
      return;
    }
    onSelection(localSelected);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-6 sm:mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-primary-900 mb-4">
          Select Studio
        </h2>
        <p className="text-base sm:text-lg text-primary-600">
          Please select a studio.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
        {studios.map((studio) => (
          <div
            key={studio.id}
            className={`relative border-2 rounded-lg p-4 sm:p-6 cursor-pointer transition-all duration-200 ${
              localSelected.includes(studio.id)
                ? "border-primary-500 bg-primary-100 shadow-lg"
                : "border-primary-200 hover:border-primary-300 hover:shadow-md"
            }`}
            onClick={() => handleStudioToggle(studio.id)}
          >
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="flex-shrink-0">
                <div
                  className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center ${
                    localSelected.includes(studio.id)
                      ? "border-primary-600 bg-primary-600"
                      : "border-primary-300"
                  }`}
                >
                  {localSelected.includes(studio.id) && (
                    <div className="w-2 h-2 sm:w-3 sm:h-3 bg-white rounded-full"></div>
                  )}
                </div>
              </div>

              <div className="flex-1">
                <h3 className="text-lg sm:text-xl font-semibold text-primary-900">
                  {studio.name}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-3 sm:space-y-0">
        {currentStep > 1 && (
          <button
            onClick={onBack}
            className="px-4 sm:px-6 py-3 border border-primary-300 rounded-lg text-primary-700 hover:bg-primary-50 transition-colors text-sm sm:text-base"
          >
            ← Back
          </button>
        )}

        <button
          onClick={handleNext}
          disabled={localSelected.length === 0}
          className={`px-6 sm:px-8 py-3 rounded-lg font-medium transition-colors text-sm sm:text-base ${
            localSelected.length === 0
              ? "bg-primary-300 text-primary-500 cursor-not-allowed"
              : "bg-primary-600 text-white hover:bg-primary-700"
          }`}
        >
          Select Time Slots →
        </button>
      </div>
    </div>
  );
};

export default StudioSelector;
